import { render, staticRenderFns } from "./organizations.vue?vue&type=template&id=c7838460"
import script from "./organizations.vue?vue&type=script&lang=js"
export * from "./organizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports